<template>
	<div class="container-fluid" id="noPadding">
		<div class="col-xs-12 col-xs-offset-0">	
				
				<div v-show="showmobileguide" key="mobileinfo">
					<p id="welcomeInfoText"> 
						A Horrifying Halloween Sound Experiment.
					</p>
				</div>	

					<router-link to="/" tag="li" active-class="active" exact> 
				         <button 
				            class="btn btn-blackwhite btn-lg"
				            id="playButton" 
				            @click='startAudio'
				          	><strong> Click To Scare, If You Dare. </strong>
			         	</button>
			      	</router-link>	
			   
			      	<br>
			      	<br>

			    <div v-show="showmobileguide" key="mobileinfo">
			      	<p id="welcomeMobileText"> 
			      	<i :class="bellSlash"></i> 
			      	<br> 
			      	Please make sure your <strong> mute button is off </strong> and volume is engaged.
					<br>
					<br>
					<!-- <strong> Parental Advisory: </strong> -->
			      	<!-- <br>
			      	This web app plays scary sounds.  --></p>
				</div>
		</div>
	</div>
</template>

<script>
import StartAudioContext from '../../node_modules/startaudiocontext/StartAudioContext.js'
import Tone from '../../node_modules/Tone/build/Tone.min.js'

	export default {
		data: () => ({
			showmobileguide: true,
			bellBoolean:     false,
			// windIntroPlayer: new Tone.Player({
		 //  					"url" : "../src/assets/windintro.wav",
		 //  					"playbackRate" : 2,
		 //  						"autostart" : false,
		 //  						"loop" : false,
		 //  						"retrigger" : false,
		 // 			 			}).toMaster(),
		}),

		created(){
				window.AudioContext = window.AudioContext || window.webkitAudioContext
				setTimeout(this.bellTrue, 1500);
				},
		computed: {
				bellSlash(){
					return{
						"fa fa-bell fa-2x": this.bellBoolean,
						"fa fa-bell-slash fa-2x": !this.bellBoolean
					}
				},
		},
		methods: {
				bellTrue(){
					this.bellBoolean = true;
				},
				startAudio(){
						Tone.context = new AudioContext();
						StartAudioContext(Tone.context, "#playButton");
				},
			}
		}
</script>


// WEBPACK FOOTER //
// welcome.vue?cc2b0f30